module.exports = __webpack_public_path__ + "images/theblueseed_logo.svg";


//////////////////
// WEBPACK FOOTER
// ./images/theblueseed_logo.svg
// module id = 18
// module chunks = 1